import React, { useState, useEffect } from "react";
import axios from "axios"; // Make sure to install axios: npm install axios or yarn add axios
import { Container, Col, Form, Row } from "react-bootstrap";

const SentMessages = () => {
  // State variables
  const [sentItems, setSentItems] = useState([]); // To store the fetched data

  const [loading, setLoading] = useState(true); // To indicate data fetching is in progress

  const [error, setError] = useState(null); // To store any error during fetching

  // API URL (Adjust protocol if necessary)
  const API_URL = "http://localhost:5000/sentmessage"; // Added https://

  useEffect(() => {
    // Create an AbortController for potential cleanup
    const abortController = new AbortController();
    const signal = abortController.signal;

    const fetchSentItems = async () => {
      setLoading(true); // Start loading
      setError(null); // Reset error state
      setSentItems([]); // Clear previous data

      try {
        const response = await axios.get(API_URL, { signal }); // Pass the signal to axios

        // Assuming the data is directly in response.data and is an array
        if (Array.isArray(response.data)) {
          setSentItems(response.data);
        } else {
          // Handle cases where response.data is not an array as expected
          console.error("API response is not an array:", response.data);
          setError(
            new Error("Received unexpected data format from the server.")
          );
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log("Request canceled:", err.message);
        } else {
          // Handle other errors (network, server errors, etc.)
          console.error("Error fetching sent items:", err);
          setError(err); // Store the error object
        }
      } finally {
        // Ensure loading is set to false regardless of success or failure,
        // but only if the error wasn't due to cancellation (component unmount)
        if (!axios.isCancel(error)) {
          setLoading(false); // Stop loading
        }
      }
    };

    fetchSentItems();

    // Cleanup function: Abort the request if the component unmounts
    return () => {
      abortController.abort();
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  // --- Rendering Logic ---

  if (loading) {
    return <div aria-live='polite'>Loading sent items...</div>;
  }

  if (error) {
    return (
      <div style={{ color: "red" }} role='alert'>
        Error fetching data: {error.message || "An unknown error occurred."}
        {error.response && (
          <p>
            Status: {error.response.status} - {error.response.statusText}
          </p>
        )}
      </div>
    );
  }

  if (sentItems.length === 0) {
    return <div>No sent items found.</div>;
  }

  return (
    <Container>
      <div>
        <h2>Sent SMS Items</h2>
        <table border='1' style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
              <th>Sender ID</th>
              <th>Recipient</th>
              <th>Status</th>
              <th>Units Used</th>
              <th>Date Sent</th>
              <th>Channel</th>
            </tr>
          </thead>
          <tbody>
            {sentItems.map((item, index) => (
              // Use item.id if available and unique, otherwise fallback to index (less ideal)
              <tr key={item.msg_id || index}>
                {/* Adjust item.propertyName based on your actual API response structure */}
                <td>{item.msg_sender}</td>
                <td>{item.msg_destination}</td>
                <td>{item.msg_status}</td>
                <td>{item.msg_units}</td>
                <td>
                  {
                    /* Format date if needed */ new Date(
                      item.msg_created
                    ).toLocaleString()
                  }
                </td>
                <td>{item.msg_channel}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Container>
  );
};

export default SentMessages;
